// @ts-nocheck
import * as React from 'react';
import Autosuggest from 'react-autosuggest';
import type { SuggestionType } from 'commons/types';
import TypeaheadWrapper from './Typeahead.styles';
import type { TypeaheadProps, TypeaheadState, SuggestionsContainerProps } from './Typeahead.types';

class Typeahead extends React.Component<TypeaheadProps, TypeaheadState> {
  constructor(props: TypeaheadProps) {
    super(props);
    this.state = {
      error: false,
    };
  }

  onKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      const {
        value,
        suggestions = [],
        onSuggestionSelected,
        hasToSelect,
        ignoreEnter = false,
      } = this.props;

      if (ignoreEnter) {
        return;
      }

      if (suggestions.length > 0 && suggestions[0].name) {
        e.preventDefault();
        const { name } = suggestions[0];

        if (!hasToSelect || (name && value && value.toLowerCase() === name.toLowerCase())) {
          // Pressed Enter, but the text witten matches the first suggestion
          onSuggestionSelected(null, {
            suggestion: suggestions[0],
          });
        } else {
          this.setState({
            error: true,
          });
        }
      } else if (hasToSelect) {
        e.preventDefault();
        this.setState({
          error: true,
        });
      }
    } else {
      this.setState({
        error: false,
      });
    }
  };

  getSuggestionValue = (suggestion: SuggestionType): string | null | undefined => {
    const { name, label } = suggestion;
    const currentName = name || label;
    return currentName;
  };

  renderSuggestion = (suggestion: SuggestionType): React.ReactElement<any> => (
    <div className='typeahead__autosuggest__container__suggestion'>
      <span>{suggestion.name}</span>
    </div>
  );

  renderSuggestionsContainer = ({
    containerProps,
    children,
  }: SuggestionsContainerProps): React.ReactElement<any> => {
    const className = ` ${containerProps.className} typeahead__autosuggest__container`;
    return (
      <div {...containerProps} className={className}>
        <span className='typeahead__autosuggest__container__separator' />
        {children}
      </div>
    );
  };

  render() {
    const {
      disabled,
      length,
      name,
      onChange,
      onSuggestionsFetchRequested,
      onSuggestionsClearRequested,
      onSuggestionSelected,
      pattern,
      placeholder,
      suggestions = [],
      validationMessage = '',
      value = '',
    } = this.props;
    const { error } = this.state;
    const inputProps = {
      className: error ? 'input-error' : '',
      disabled,
      maxLength: length,
      minLength: length,
      name,
      onChange,
      onKeyPress: this.onKeyPress,
      pattern,
      placeholder,
      title: validationMessage,
      value: String(value),
    };
    return (
      <TypeaheadWrapper>
        <Autosuggest
          className='typeahead__autosuggest'
          disabled={disabled}
          focusInputOnSuggestionClick={false}
          getSuggestionValue={this.getSuggestionValue}
          inputProps={inputProps}
          onSuggestionsClearRequested={onSuggestionsClearRequested}
          onSuggestionsFetchRequested={onSuggestionsFetchRequested}
          onSuggestionSelected={onSuggestionSelected}
          renderSuggestion={this.renderSuggestion}
          renderSuggestionsContainer={this.renderSuggestionsContainer}
          suggestions={suggestions}
        />
      </TypeaheadWrapper>
    );
  }
}

export default Typeahead;
